import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import './index.scss';
import { MTNewDigitalDisplayStyle, convertCentsToYuanInteger } from "@/utils/common";
import { SystemType, getSystemType } from '@nibfe/mkt-env-api';
import ModalBottomBtn from "../modal-bottom-button";
export default function UnlockedFreeCardPopup(props) {
    const { fullScreenHeight } = getFullScreenSize();
    const systemType = getSystemType();
    const isIOS = systemType === SystemType.ios;
    if (!props.visible) {
        return null;
    }
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/84ba79a9e5edae5b8eb2bd105b7e43c037624.png'
    }} style={{
        width: '564rpx',
        height: '789rpx',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
        // paddingTop: '260rpx',
    }}>
          
          <View className="unlocked-popup-card">
            
            <View className="unlocked-popup-reward-content">
              
              <View className="free-card-tag">
                <View className="free-card-tag-icon">
                  <Text className="free-card-tag-text">免</Text>
                </View>
                <Text className="free-card-tag-desc">1房1晚·实付价</Text>
              </View>

              
              <View className="unlocked-popup-amount-container">
                <Text className="unlocked-popup-amount-label">最高</Text>
                <Text className="unlocked-popup-amount" style={Object.assign(Object.assign({}, MTNewDigitalDisplayStyle), { top: isIOS ? '10rpx' : '0rpx' })}>{convertCentsToYuanInteger(props.freeCardMaxAmount)}</Text>
                <Text className="unlocked-popup-amount-unit">元</Text>
              </View>
            </View>

            
            <Text className="unlocked-popup-tip">再邀 1 位好友助力即可领取奖励</Text>

            
            <View style={{
        marginTop: '113rpx'
    }}>
              <ModalBottomBtn buttonText={'邀好友领取奖励'} onPress={props.onInviteUnlock}/>
            </View>
          </View>
        </LImage>

        
        <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} className="unlocked-popup-close-btn"/>
      </ModalBaseContainer>
    </TopView>;
}
